import { addSlidesTabIndex } from '@gravity-global/helpers/swiper/add-slides-tab-index';
import Gravity from 'gravityglobal-parent/assets/js/global-functions';

const sliderLogoCarousel = () => {
    document
        .querySelectorAll('.gg-logo-slider .wp-block-statik-slider > .swiper')
        .forEach((clientLogosCarousel) => {
            const slidesInCarousel = clientLogosCarousel.swiper.slides.filter(slide => !slide.classList.contains('swiper-slide-duplicate'));
            const numberOfSlides = slidesInCarousel.length;

            clientLogosCarousel.swiper.params.autoplay = {
                disableOnInteraction: false, 
            };
            
            clientLogosCarousel.swiper.params.watchSlidesProgress = true;
            clientLogosCarousel.swiper.params.spaceBetween = 0;
            clientLogosCarousel.swiper.params.speed = 5000;
            clientLogosCarousel.swiper.params.grabCursor = false;
            clientLogosCarousel.swiper.params.allowTouchMove = false;
            clientLogosCarousel.swiper.params.breakpoints = {
                0: {
                    slidesPerView: numberOfSlides < 2 ? numberOfSlides : 2,
                },
                600: {
                    slidesPerView: numberOfSlides <= 3 ? numberOfSlides : 3,
                },
                1025: {
                    slidesPerView: numberOfSlides < 6 ? numberOfSlides : 6,
                },
            };
            
        });
};

Gravity.ready(sliderLogoCarousel);
